/**
 * A LIST'S FILTERS, EACH WITH ITS COUNT.
 *
 * The count is the answer to "is there anything here?" before anyone clicks, so
 * it is part of the control rather than a separate summary. A count the caller
 * does not know is omitted, never drawn as 0.
 */
export interface FilterOption<T extends string> {
  readonly id: T;
  readonly label: string;
  readonly count?: number;
  /** A filter that holds something the producer must act on. */
  readonly tone?: 'attention';
}

export function SegmentedFilter<T extends string>({
  options,
  value,
  onChange,
  label,
  testIdPrefix,
}: {
  options: readonly FilterOption<T>[];
  value: T;
  onChange: (next: T) => void;
  label: string;
  testIdPrefix: string;
}) {
  return (
    <div className="ui-filters" role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          className="ui-filter"
          aria-pressed={value === o.id}
          data-tone={o.tone}
          data-testid={`${testIdPrefix}-${o.id}`}
          onClick={() => {
            onChange(o.id);
          }}
        >
          <span>{o.label}</span>
          {o.count === undefined ? null : <span className="ui-filter-count">{String(o.count)}</span>}
        </button>
      ))}
    </div>
  );
}
